module.exports = __webpack_public_path__ + "img/successPayment.b6b8f55e.svg";